import { appLogicList } from './app/logic'
import { scansLogic } from './scans/logic'
import { authLogicList } from './auth/logic'
import { adminLogicList } from './admin/logic'
import { invoicesLogic } from './invoices/logic'
import { qaChecksLogic } from './qaChecks/logic'
import { accidentsLogic } from './accidents/logic'
import { employeesLogic } from './employees/logic'
import { applicationsLogic } from './applications/logic'
import { fetchTerminationsLogic } from './terminations/logic'

export const logicList = [
  ...scansLogic,
  ...appLogicList,
  ...authLogicList,
  ...invoicesLogic,
  ...qaChecksLogic,
  ...accidentsLogic,
  ...adminLogicList,
  ...employeesLogic,
  ...applicationsLogic,
  ...fetchTerminationsLogic
]



// WEBPACK FOOTER //
// ./src/store/logicList.ts